import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import PriceSummary from '../components/priceSummary/PriceSummary';
import PriceDetails from '../stores/PriceDetails';

export default observer((props) => {
	const [priceDetails, setPriceDetails] = useState();
	const [error, setError] = useState(null);

	const { customer, config, planId, country, vatNumber, isMobile, couponCode, showCoupon, promotionId, discountId } = props;

	const billingDetails = customer?.billingDetails || {};

	useEffect(() => {
		const newPriceDetails = new PriceDetails({
			sumupService: config.sumupService,
			sumupSubscriptionsService: config.sumupSubscriptionsService,
			customerCountryCode: country,
			planId,
			vatNumber,
			zipCode: billingDetails.zip,
			addressLine1: billingDetails.addressLine1,
			city: billingDetails.city,
			state: billingDetails.state,
			couponCode,
			promotionId,
			discountId,
		});

		newPriceDetails.fetchPriceDetails().catch(setError);

		setPriceDetails(newPriceDetails);
	}, [planId, couponCode, country, vatNumber, promotionId, discountId, billingDetails.zip, billingDetails.addressLine1, billingDetails.city, billingDetails.state]);

	useEffect(() => {
		customer?.setPlanName(priceDetails?.planName);
	}, [priceDetails?.planName]);

	if (error) {
		throw error;
	}

	return (
		<PriceSummary
			priceDetails={priceDetails}
			isMobile={isMobile}
			couponCode={couponCode}
			showCoupon={showCoupon}
		/>
	);
});
